export class Portofolio {
  constructor(data = null) {
    this.portofolio_id = 0
    this.portofolio_url = ''
    this.user_id = null
    this.title = ''
    this.display_name = ''
    this.introduction = ''
    this.is_show_career = 0
    this.started_at = null
    this.ended_at = null
    this.is_stopped = 0
    this.is_deleted = 0
    this.created_at = null
    this.updated_at = null
    this.pfIcoDataURL = ''
    this.pfBgDataURL = ''
    this.achievements = []
    this.profiles = {}
    this.views = []
    if (data) {
      this.setPortofolio(data)
    }
  }

  // ポートフォリオの情報を丸ごとセット
  setPortofolio(data) {
    // 存在したパラメータだけ上書き（プロフィールのデフォルト値などを想定)
    if ('portofolio_id' in data) {
      this.setPortofolioId(data.portofolio_id)
    }
    if ('portofolio_url' in data) {
      this.setPortofolioUrl(data.portofolio_url)
    }
    if ('user_id' in data) {
      this.setUserId(data.user_id)
    }
    if ('title' in data) {
      this.setTitle(data.title)
    }
    if ('display_name' in data) {
      this.setDisplayName(data.display_name)
    }
    if ('introduction' in data) {
      this.setIntroduction(data.introduction)
    }
    if ('is_show_career' in data) {
      this.setIsShowCareer(data.is_show_career)
    }
    if ('started_at' in data) {
      this.setStartedAt(data.started_at)
    }
    if ('ended_at' in data) {
      this.setEndedAt(data.ended_at)
    }
    if ('is_stopped' in data) {
      this.setIsStopped(data.is_stopped)
    }
    if ('is_deleted' in data) {
      this.setIsDeleted(data.is_deleted)
    }
    if ('created_at' in data) {
      this.setCreatedAt(data.created_at)
    }
    if ('updated_at' in data) {
      this.setUpdatedAt(data.updated_at)
    }
    if ('pfIcoDataURL' in data) {
      this.setPfIcoDataURL(data.pfIcoDataURL)
    }
    if ('pfBgDataURL' in data) {
      this.setPfBgDataURL(data.pfBgDataURL)
    }
    if ('achievements' in data) {
      this.setAchievements(data.achievements)
    }
    if ('profiles' in data) {
      this.setProfiles(data.profiles)
    }
    if ('views' in data) {
      this.setViews(data.views)
    }
  }

  setPortofolioId(portofolioUrlId) {
    this.portofolio_id = Number(portofolioUrlId)
  }

  setPortofolioUrl(portofolioUrl) {
    this.portofolio_url = portofolioUrl
  }

  setUserId(userId) {
    this.user_id = userId ? Number(userId) : null
  }

  setTitle(title) {
    this.title = title
  }

  setDisplayName(displayName) {
    this.display_name = displayName
  }

  setIntroduction(introduction) {
    this.introduction = introduction
  }

  setIsShowCareer(isShowCareer) {
    this.is_show_career = Number(isShowCareer)
  }

  setStartedAt(staredAt) {
    this.started_at = staredAt
  }

  setEndedAt(endedAt) {
    this.ended_at = endedAt
  }

  setIsStopped(isStopped) {
    this.is_stopped = Number(isStopped)
  }

  setIsDeleted(isDeleted) {
    this.is_deleted = Number(isDeleted)
  }

  setCreatedAt(createdAt) {
    this.created_at = createdAt
  }

  setUpdatedAt(updatedAt) {
    this.updated_at = updatedAt
  }

  setPfIcoDataURL(pfIcoDataURL) {
    this.pfIcoDataURL = pfIcoDataURL
  }

  setPfBgDataURL(pfBgDataURL) {
    this.pfBgDataURL = pfBgDataURL
  }

  setAchievements(achievements) {
    this.achievements = Array.isArray(achievements) ? achievements : []
  }

  setProfiles(profiles) {
    this.profiles = typeof profiles === 'object' ? profiles : {}
  }

  setViews(views) {
    this.views = Array.isArray(views) ? views : []
  }
}
